module.exports = __webpack_public_path__ + "74d1c0f9cad5b83bcce52f314776d54f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio1/pr5.jpg
// module id = 904
// module chunks = 0